import {StructuredText as DatoStructuredText} from 'react-datocms/structured-text';

function getBlocks(document: any) {
  return document.children.reduce((blocks: any[], child: any) => {
    if (child.type === 'block') {
      blocks.push({id: child.item});
    } else if (child.children) {
      blocks.push(...getBlocks(child));
    }
    return blocks;
  }, []);
}

export const StructuredText = ({document}: {document: any}) => {
  return (
    <div className="StructuredText">
      <DatoStructuredText
        data={{
          value: {
            schema: 'dast',
            document: document as any,
          },
          blocks: getBlocks(document as any),
        }}
        renderBlock={() => null}
      />
    </div>
  );
};
